import React, { useState } from 'react';
import { Card, CardContent, CardMedia, Typography, Button, Grid } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ProductDetailModal from './ProductDetailModal';

const ProductDetails = ({ productData }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const[opendialog,setOpendialog]=useState(false);
    const[product,setProduct]=useState({});
    const[role,setRole]=useState('user');

    const handleProductClick = (e) => {
        setProduct(e);
        setOpendialog(true)
    };

    return (
        <Grid container spacing={0}>
            <Grid item xs={12}>
                <Typography variant="h5" sx={{ my: 4 }}>{t("OurProducts")}</Typography>
                <Grid container spacing={2}>
                    {productData?.map((product) => (
                        <Grid item key={product.id} xs={12} sm={6} md={6}>
                            <Card  sx={{ maxWidth: 350, p: 2, cursor: 'pointer', boxShadow: 3, transition: 'transform 0.2s', '&:hover': { transform: 'scale(1.05)' } }}>
                                <CardMedia
                                    component="img"
                                    height="200"
                                    image={product.product_image || './profile_pic.png'}
                                    alt={product.product_name}
                                    sx={{ objectFit: 'contain' }}
                                />
                                <CardContent>
                                    <Typography gutterBottom variant="h5" component="div">
                                        {product.product_name}
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        {product.product_description}
                                    </Typography>
                                </CardContent>
                                {/* <Button size="small" onClick={() => handleProductClick(product.id)} sx={{ mt: 1 }}>Learn More</Button> */}
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Grid>
            <ProductDetailModal open={opendialog} onClose={() => setOpendialog(false)} 
                                product={product}
                                role={role}
                                
                            />
        </Grid>
    );
};

export default ProductDetails;